import styled from 'styled-components';

interface CircularLoadingProps {
  width: number | string;
  height: number | string;
}

const CircularLoading = ({ width, height }: CircularLoadingProps) => {
  return <LoadingContainer width={width} height={height} />;
};

const LoadingContainer = styled.div<CircularLoadingProps>`
  border: 3px solid #015c9a;
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: ${props => props.width};
  height: ${props => props.height};
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default CircularLoading;
